export const defaultState = () => {
    return {
        fhir: {},
        rejected: [],
        accepted: [],
        transfered: [],
        applied: false
    }
}

const state = defaultState()
export default state
